import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setIsSearching')(function setIsSearching(
    viewState: AtMentionsViewState,
    isSearching: boolean,
    queryString?: string
) {
    viewState.isSearching = isSearching;
    if (queryString != null) {
        viewState.queryString = queryString;
    }
});
